import { usdToTokenAmount } from '@funkit/connect-core'
import type { DepositInitialAmount } from '../flow/depositFlowConfig'

export function isPositiveFinite(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0
}

export function resolveFiatRate(
  initialAmount: DepositInitialAmount,
  exchangeRates?: Record<string, number>,
): number | undefined {
  if (initialAmount.currency === 'USD') {
    return 1
  }
  const rate = exchangeRates?.[initialAmount.currency]
  return isPositiveFinite(rate) ? rate : undefined
}

/**
 * Advisory send amount, not a route quote or backend authorization.
 * Round down to the token precision (up to eight decimals) and copy exactly what is displayed.
 */
export function lockedTokenAmount(
  initialAmount: DepositInitialAmount,
  tokenUsdPrice: number,
  exchangeRates?: Record<string, number>,
  decimals = 8,
): string | undefined {
  const rate = resolveFiatRate(initialAmount, exchangeRates)
  if (rate === undefined || !isPositiveFinite(tokenUsdPrice)) {
    return undefined
  }
  const usd = usdToTokenAmount(initialAmount.value, rate, 18)
  const token = usdToTokenAmount(usd, tokenUsdPrice, Math.min(decimals, 8))
  return Number(token) > 0 ? token : undefined
}
